import React from 'react';
import Icon from '../../../components/AppIcon';

const ActivityItem = ({ activity }) => {
  const getActivityIcon = (type) => {
    const icons = {
      quiz: 'ClipboardCheck',
      recommendation: 'Lightbulb',
      achievement: 'Award',
      exploration: 'Compass'
    };
    return icons?.[type] || 'Activity';
  };

  const getActivityColor = (type) => {
    const colors = {
      quiz: 'text-blue-600 bg-blue-50 dark:text-blue-400 dark:bg-blue-900/20',
      recommendation: 'text-green-600 bg-green-50 dark:text-green-400 dark:bg-green-900/20',
      achievement: 'text-amber-600 bg-amber-50 dark:text-amber-400 dark:bg-amber-900/20',
      exploration: 'text-purple-600 bg-purple-50 dark:text-purple-400 dark:bg-purple-900/20'
    };
    return colors?.[type] || 'text-gray-600 bg-gray-50';
  };

  const formatTimeAgo = (timestamp) => {
    const now = new Date();
    const activityTime = new Date(timestamp);
    const diffInMinutes = Math.floor((now - activityTime) / (1000 * 60));
    
    if (diffInMinutes < 60) return `Il y a ${diffInMinutes} min`;
    if (diffInMinutes < 1440) return `Il y a ${Math.floor(diffInMinutes / 60)} h`;
    return `Il y a ${Math.floor(diffInMinutes / 1440)} j`;
  };

  return (
    <div className="flex items-start gap-3 md:gap-4 p-3 md:p-4 rounded-lg hover:bg-muted transition-colors duration-200">
      <div className={`w-10 h-10 md:w-12 md:h-12 rounded-full ${getActivityColor(activity?.type)} flex items-center justify-center flex-shrink-0`}>
        <Icon name={getActivityIcon(activity?.type)} size={20} className="md:w-6 md:h-6" />
      </div>
      <div className="flex-1 min-w-0">
        <h4 className="text-sm md:text-base font-medium text-foreground mb-1 line-clamp-2">
          {activity?.title}
        </h4>
        <p className="text-xs md:text-sm text-muted-foreground line-clamp-2">
          {activity?.description}
        </p>
        <p className="text-xs text-muted-foreground mt-1">
          {formatTimeAgo(activity?.timestamp)}
        </p>
      </div>
      {activity?.points && (
        <div className="flex items-center gap-1 bg-accent/10 text-accent px-2 py-1 rounded-md flex-shrink-0">
          <Icon name="Plus" size={12} />
          <span className="text-xs md:text-sm font-medium whitespace-nowrap">
            {activity?.points} pts
          </span>
        </div>
      )}
    </div>
  );
};

export default ActivityItem;